import React from "react";
import "../../../css/TotalRide.css";
import mobility from "../../../img/ride.png";

interface TotalRideProps {
  TotalRide: number;
}

const TotalRide = ({ TotalRide }: TotalRideProps) => {
  return (
    <div className="total_ride_container">
      <div className="total_ride_display">
        <img className="mobility" src={mobility} />
        <div className="total_ride_title">累計乗車金額</div>
      </div>
      <div className="total_ride_of">
        {TotalRide.toLocaleString()}
        <span className="unit">円</span>
      </div>
    </div>
  );
};

export default TotalRide;
